import React from "react"
import colors from "../../Constants/colors"

import ButtonSelection from "../ButtonSelection/ButtonSelection"
import PYPLayoutContainer from "../PYPLayoutContainer/PYPLayoutContainer.js"
import PYPPartTitleContent from "../PYPPartTitleContent/PYPPartTitleContent.js"
import "./LayoutButtonSelectionMetaData.css"
import SkeletonButtons from "../SkeletonButtons/SkeletonButtons.js"

import { bindActionCreators } from "redux"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import Actions from "../../Redux/Actions"

class LayoutButtonSelectionMetaData extends React.Component {
  constructor(props) {
    super(props)

    this.changeHandler = this.changeHandler.bind(this)
  }

  componentDidMount() {
    this.props.fetchPartData()
  }

  componentDidUpdate(prevProps) {}

  changeHandler(inputData) {
    this.props.setButtonSelection(inputData[0])
  }

  render() {
    const buttonValues = this.props.buttonValues || []
    const selectionLimit = buttonValues.length >= 10 ? 10 : 3
    const buttonComponent = buttonValues.length > 0 ? (
      <ButtonSelection
        limit={selectionLimit}
        // didAddButton and customButtonPlaceHolder are probably deprecated - it's from the customButtonValues
        didAddButton={(name) => {
          this.props.createButton(
            name,
            this.props.currentPart.id,
            this.props.user.user.id
          )
        }}
        customButtonPlaceholder="Add a value"
        changeHandler={this.changeHandler}
        inputData={buttonValues}
        renderComponent={({ inputComponent }) => (
          <div
            style={{
              width: "100%",
              marginBottom: "100px"
            }}
          >
            {inputComponent}
          </div>
        )}
      />
    ) : (
      <SkeletonButtons />
    )

    return (
      <PYPLayoutContainer
        backgroundColor={colors.background}
        style={{ ...this.props.style }}
      >
        <div
          className="buttonSelectionLayout"
          style={{ ...styles.componentContainer, ...this.props.style }}
        >
          <div>
            <PYPPartTitleContent
              title={this.props.title.title}
              description={this.props.title.description}
            />
          </div>
          {buttonComponent}
        </div>
      </PYPLayoutContainer>
    )
  }
}

const styles = {
  componentContainer: {
    width: "100%", // 80%?
    height: "100%", // 80%?
    backgroundColor: colors.background,
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  inputBoxContainer: {
    width: "100%",
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center"
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch)
}

const mapStateToProps = (state, props) => {
  try {
    const currentPart = state.pyp?.parts?.byId?.[state.pyp?.navigation?.currentPartId]
    const partDataId = currentPart?.partData

    let buttonValues = []
    let metadata = { title: null, description: null }

    const partData =
      partDataId &&
      state.pyp?.partData?.byId?.[partDataId] &&
      state.pyp.partData.byId[partDataId].data
    if (partData) {
      // Safely access title
      if (partData.title && Array.isArray(partData.title) && partData.title.length > 0) {
        metadata = partData.title[0]
      }
      
      // Safely access buttonValues
      if (partData.buttonValues && Array.isArray(partData.buttonValues)) {
        buttonValues = partData.buttonValues.map((buttonValue) => {
          // Check if buttonSelections exist and have at least one selection
          // For Stage 1: A button is selected if it has buttonSelections with any stage
          // (stage: null, 1, or 2 - all represent selections made in Stage 1)
          const hasSelection = buttonValue && 
                              buttonValue.buttonSelections && 
                              Array.isArray(buttonValue.buttonSelections) && 
                              buttonValue.buttonSelections.length > 0
          
          // Find the first selection (prefer Stage 1 if multiple exist)
          const firstSelection = hasSelection 
            ? (buttonValue.buttonSelections.find((sel: any) => {
                const stage = sel?.pivot?.stage
                return stage === null || stage === undefined || stage === 1
              }) || buttonValue.buttonSelections[0])
            : null
          
          return {
            value: buttonValue?.name || '',
            id: buttonValue?.id,
            isCustom: buttonValue?.isCustom || false,
            isSelected: hasSelection ? true : false,
            buttonSelection: firstSelection
          }
        })
        // alphabetize only the non-custom buttons
        // const customButtons = buttonValues.filter(value => value.isCustom).reverse()
        const defaultButtons = buttonValues
          .filter((value) => !value.isCustom)
          .sort((a, b) =>
            a.value.toUpperCase() > b.value.toUpperCase()
              ? 1
              : b.value.toUpperCase() > a.value.toUpperCase()
              ? -1
              : 0
          )

        buttonValues = [...defaultButtons]
      }
    }

    return {
      ...props,
      pyp: state.pyp,
      currentPart,
      partDataId,
      buttonValues: buttonValues || [], // Ensure it's always an array
      title: metadata,
      user: state.user
    }
  } catch (e) {
    // Return safe defaults if there's an error
    return {
      ...props,
      pyp: state.pyp,
      currentPart: null,
      partDataId: null,
      buttonValues: [], // Always return an array
      title: { title: null, description: null },
      user: state.user
    }
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LayoutButtonSelectionMetaData)
)
